import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';

import { environment } from './../../environments/environment';

import { Configurations } from "../core/configurations";
import { IncassoModel } from './../models/incassi/incasso.model';
import { IncassoListItemModel } from "../models/incassi/incasso-list-item.model";
import { DizionarioModel } from './../models/shared/dizionario.model';
import { PagedListModel } from "../models/shared/paged-list.model";
import { guid, newId } from '../core/utilities';
import { LocalDb } from '../core/localdb';
import {AuthService} from './auth.service';


@Injectable()
export class IncassiService {
  APIIncassi = this.configuration.apiBaseUrlIncassi;
  APITipiAssegni = this.configuration.apiBaseUrlTipiAssegni;
  MethodInLavorazione = "inLavorazione";
  MethodDaRendicontare = "daRendicontare";
  MethodByCliente = "getByCliente";
  apiBaseUrlStampe = this.configuration.apiBaseUrlStampe;

  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) {
  }


  getListInLavorazione(): Observable<IncassoListItemModel[]> {
    
    let url = this.APIIncassi + this.MethodInLavorazione;
    return this.http.get(url)
      .map((r: Response) => r.json() as IncassoListItemModel[]).catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  
    }

  getListDaRendicontare(): Observable<IncassoModel[]> {

    let url = this.APIIncassi + this.MethodDaRendicontare;
    return this.http.get(url)
      .map((r: Response) => r.json() as IncassoModel[]).catch((r:any)=> {
        
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });

  }



  getTipiAssegno(): Observable<DizionarioModel[]> {
    
    let url = this.APITipiAssegni;
    return this.http.get(url)
      .map((r: Response) => r.json() as DizionarioModel[])
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  
    }

  /** restituisce l'unico incasso in lavorazione o nuovo per il cliente
   */
  getByCliente(clienteGid: string): Observable<IncassoModel> {
    
    let url = this.APIIncassi + this.MethodByCliente;
    return this.http.get(url + '/' + clienteGid)
      .map((r: Response) => r.json() as IncassoModel)
      .catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });

  }


  insert(model: IncassoModel): Observable<Response> {
    
    let url = this.APIIncassi;
    return this.http.post(url, model).map(res => { 
      return res.json(); })
      .catch((error: any) => Observable.throw(error));

  }
  update(model: IncassoModel): Observable<Response> {
    
    let url = this.APIIncassi;
    return this.http.put(url, model).map(res => {
       return res.json();  })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });

  }

 

  delete(model: IncassoModel):  Observable<Response>  {

    let url = this.APIIncassi;
    return this.http.delete(url +  model.tokenIncasso).map(res => { 
      return res.json();  })
    .catch((r:any)=> {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });


  }

    
}

//OLD
/*
const STATO_INCASSI: DizionarioModel[] = [
  { id: 1, descrizione: 'Nuovo' },
  { id: 2, descrizione: 'In Lavorazione' },
  { id: 3, descrizione: 'Chiuso (ricevuta emessa)' },
  { id: 4, descrizione: 'Archiviato (collegato a brogliaccio)' }
];

const TIPI_ASSEGNO: DizionarioModel[] = [
  { id: 1, descrizione: 'Bancario' },
  { id: 2, descrizione: 'Circolare' },
  { id: 3, descrizione: 'Circolare versamento contanti' }
];


export const _INCASSI: IncassoModel[] = JSON.parse(`
[{
  "tokenCliente" : "01",
  "clienteRagioneSociale" : "Cliente A srl",
  "id" : 1,
  "tokenIncasso" : "01",
  "dataIncasso" : "2017-02-28T23:00:00.000Z",
  "statoIncasso" : "In Lavorazione",
  "idStatoIncasso" : 2,
  "zona" : "zona1",
  "totaleValuta" : 2648,
  "totaleAssegni" : 2000,
  "totaleIncasso" : 4648,
  "accontoPrecedente" : 0,
  "residuoDisponibile" : 4648,
  "contanti" : [{
      "idTaglio" : 1,
      "descrizioneTaglio" : "Banconote da 500€",
      "token" : "",
      "importoTaglio" : 500,
      "quantita" : "4",
      "importo" : 2000
    }, {
      "idTaglio" : 2,
      "descrizioneTaglio" : "Banconote da 200€",
      "token" : "",
      "importoTaglio" : 200,
      "quantita" : "3",
      "importo" : 600
    }, {
      "idTaglio" : 3,
      "descrizioneTaglio" : "Banconote da 100€",
      "token" : "",
      "importoTaglio" : 100
    }, {
      "idTaglio" : 4,
      "descrizioneTaglio" : "Banconote da 50€",
      "token" : "",
      "importoTaglio" : 50
    }, {
      "idTaglio" : 5,
      "descrizioneTaglio" : "Banconote da 20€",
      "token" : "",
      "importoTaglio" : 20
    }, {
      "idTaglio" : 6,
      "descrizioneTaglio" : "Banconote da 10€",
      "token" : "",
      "importoTaglio" : 10,
      "quantita" : "2",
      "importo" : 20
    }, {
      "idTaglio" : 7,
      "descrizioneTaglio" : "Banconote da 5€",
      "token" : "",
      "importoTaglio" : 5,
      "quantita" : "5",
      "importo" : 25
    }, {
      "idTaglio" : 8,
      "descrizioneTaglio" : "Monete",
      "token" : "",
      "importoTaglio" : null,
      "importo" : "3"
    }
  ],
  "assegni" : [{
      "nomeBanca" : "unicredit",
      "abi" : "31332",
      "cab" : "12123",
      "numeroAssegno" : "1231234134545",
      "importo" : "2000",
      "dataAssegno" : "11/09/2017",
      "tipoAssegno" : {
        "id" : 1,
        "descrizione" : "Bancario"
      }
    }
  ]
}, {
  "tokenCliente" : "02",
  "clienteRagioneSociale" : "Cliente B srl",
  "id" : 2,
  "tokenIncasso" : "02",
  "dataIncasso" : "2017-09-21T09:05:58.074Z",
  "statoIncasso" : "In Lavorazione",
  "idStatoIncasso" : 3,
  "zona" : "zona1",
  "totaleValuta" : 0,
  "totaleAssegni" : 3500,
  "totaleIncasso" : 3500,
  "accontoPrecedente" : 0,
  "residuoDisponibile" : 550,
  "assegni" : [{
      "nomeBanca" : "ubi",
      "abi" : "41234",
      "cab" : "23423",
      "numeroAssegno" : "5513414134134",
      "importo" : "3500",
      "dataAssegno" : "20/09/2017",
      "tipoAssegno" : {
        "id" : 1,
        "descrizione" : "Bancario"
      }
    }
  ]
}, {
  "tokenCliente" : "03",
  "clienteRagioneSociale" : "Cliente C srl",
  "id" : 3,
  "tokenIncasso" : "03",
  "dataIncasso" : "2017-06-11T22:00:00.000Z",
  "statoIncasso" : "In Lavorazione",
  "idStatoIncasso" : 2,
  "zona" : "zona1",
  "totaleValuta" : 1600,
  "totaleAssegni" : 200,
  "totaleIncasso" : 1800,
  "accontoPrecedente" : 0,
  "residuoDisponibile" : 1800,
  "contanti" : [{
      "idTaglio" : 1,
      "descrizioneTaglio" : "Banconote da 500€",
      "token" : "",
      "importoTaglio" : 500,
      "quantita" : "2",
      "importo" : 1000
    }, {
      "idTaglio" : 2,
      "descrizioneTaglio" : "Banconote da 200€",
      "token" : "",
      "importoTaglio" : 200,
      "quantita" : "3",
      "importo" : 600
    }, {
      "idTaglio" : 3,
      "descrizioneTaglio" : "Banconote da 100€",
      "token" : "",
      "importoTaglio" : 100
    }, {
      "idTaglio" : 4,
      "descrizioneTaglio" : "Banconote da 50€",
      "token" : "",
      "importoTaglio" : 50
    }, {
      "idTaglio" : 5,
      "descrizioneTaglio" : "Banconote da 20€",
      "token" : "",
      "importoTaglio" : 20
    }, {
      "idTaglio" : 6,
      "descrizioneTaglio" : "Banconote da 10€",
      "token" : "",
      "importoTaglio" : 10
    }, {
      "idTaglio" : 7,
      "descrizioneTaglio" : "Banconote da 5€",
      "token" : "",
      "importoTaglio" : 5
    }, {
      "idTaglio" : 8,
      "descrizioneTaglio" : "Monete",
      "token" : "",
      "importoTaglio" : null
    }
  ]
}
]`);

*/



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/incassi.service.ts